export const storeKeys = {
	ACCOUNT_IDENTIFIER: 'account_identifier',
	DOMAIN: 'domain',
	DOMAIN_PREFIX: 'domain_prefix',
	COMPANY_NAME: 'company_name',
	EMPLOYEE_NAME: 'employee_name',
	EMPLOYEE_SESSION: 'employee_session',
	EMPLOYEE_GUID: 'employee_guid',
	ENCRYPTION_KEY: 'encryption_key',
	API_URL_VERSION: 'api_url_version',
	
	CHECKIN_CAMERA_TYPE: 'checkin_camera_type',
	APP_UPDATE_ID: 'app_update_id',
};
